module.exports = __webpack_public_path__ + "static/media/floorballshot.9b5ae057.jpg";